import React from 'react';

const TrustBarSection: React.FC = () => {
  const stats = [
    {
      icon: 'fas fa-brain',
      value: '100K+',
      label: 'Question Bank',
      color: '#667eea'
    },
    {
      icon: 'fas fa-robot',
      value: '24/7',
      label: 'AI Montor',
      color: '#764ba2'
    },
    {
      icon: 'fas fa-chart-line',
      value: '100+',
      label: 'Performance Metrics',
      color: '#2d9cdb'
    },
    {
      icon: 'fas fa-book',
      value: '200+',
      label: 'Practice Tests',
      color: '#27ae60'
    },
    {
      icon: 'fas fa-graduation-cap',
      value: 'JEE/NEET',
      label: 'Focused Platform',
      color: '#f39c12'
    }
  ];

  return (
    <div className="trust-bar-section py-4" 
      style={{ 
        background: 'linear-gradient(to right, #f8f9fa, #ffffff, #f8f9fa)',
        borderBottom: '1px solid #e9ecef'
      }}>
      <div className="container">
        <div className="row align-items-center justify-content-center g-4">
          {stats.map((stat, index) => (
            <div key={index} className="col-6 col-md-4 col-lg-2">
              <div className="text-center">
                <div className="d-flex align-items-center justify-content-center mb-2">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                    style={{
                      width: '40px',
                      height: '40px',
                      background: `${stat.color}15`,
                      border: `2px solid ${stat.color}`
                    }}>
                    <i className={stat.icon} style={{ color: stat.color }}></i>
                  </div>
                  <div>
                    <div className="fw-bold fs-4" style={{ color: stat.color, lineHeight: '1' }}>
                      {stat.value}
                    </div>
                  </div>
                </div>
                <small className="text-muted fw-semibold">{stat.label}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBarSection;
